module.exports = __webpack_public_path__ + "static/img/3.079e1ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/3.png
// module id = YD6G
// module chunks = 0